/**
 * Stable empty placeholders for useSelector fallbacks.
 * Returning a fresh `{}` / `[]` from a selector breaks === equality and can
 * nest forceUpdates under redux connect → React error #185.
 */
export const EMPTY_OBJECT = Object.freeze({});
export const EMPTY_ARRAY = Object.freeze([]);
